import {
	IonModal,
	IonButton,
	IonHeader,
	IonContent,
	IonFooter,
	IonToolbar,
	IonTitle,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import HtmlRender from "../common/html-render";


const HintsModal = ({ visible, title, hintsContent, onClose }) => {
	const { t } = useTranslation();

	return (
		<IonModal isOpen={visible} onDidDismiss={onClose}>
			<IonHeader className="hint-header">
				<IonToolbar>
					<IonTitle className="ion-text-center">{title || "Hints"}</IonTitle>
				</IonToolbar>
			</IonHeader>
			<IonContent className="hint-content" fullscreen>
				<div style={{ padding: 10 }}>
					<HtmlRender unsafeHtml={hintsContent}></HtmlRender>
				</div>
			</IonContent>
			<IonFooter>
				<IonToolbar>
					<IonButton expand="block" onClick={onClose}>
						{t("general.close")}
					</IonButton>
				</IonToolbar>
			</IonFooter>
		</IonModal>
	);
};

export default HintsModal;
